import React from "react";

export function ConditionalWall({ conditional, children }) {
    if (!conditional) {
        return null;
    }
    return <React.Fragment>{children}</React.Fragment>;
}
